import { DocumentNode } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import useDownloadApiKeyConfig from "shared/ApiKey/useDownloadApiKeyConfig";
import { ApiKey, ApiKeyInput, ApiKeyType } from "types/generated";

import { CREATE_API_KEY } from "./gql";

type UseCreateApiKeyOptions = {
  callback?: () => void;
  refetchQueries?: DocumentNode[];
};

const useCreateApiKey = ({ callback, refetchQueries }: UseCreateApiKeyOptions) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const downloadApiKeyConfig = useDownloadApiKeyConfig();

  const [createApiKey] = useMutation<{ apiKeyCreate: ApiKey }>(CREATE_API_KEY, {
    refetchQueries,
  });

  const onCreate = (input: ApiKeyInput) => {
    createApiKey({
      variables: {
        input,
      },
    })
      .then(({ data }) => {
        if (data) {
          const {
            apiKeyCreate: { name, id, type, secret },
          } = data;

          if (type === ApiKeyType.Secret) {
            if (!downloadApiKeyConfig({ id, name, secret })) {
              return;
            }
          } else if (type === ApiKeyType.Oidc) {
            reportSuccess({
              message: `API key successfully created`,
            });
          }
          callback?.();
        }
      })
      .catch(onError);
  };

  return { onCreate };
};

export default useCreateApiKey;
